// [BD Feat] Js for the preparation suggestion slider


(function () {
  function initPreparationsSlider(section) {
    const sectionId = section.dataset.sectionId;
    const carousel = section.querySelector(`#image-text-slider-carousel-${sectionId}`);

    if (!carousel || carousel.classList.contains('flickity-enabled')) return;

    const flickityInstance = new Flickity(carousel, {
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      draggable: true,
      dragThreshold: 20, // Minimum horizontal pixels to start drag
      touchVerticalScroll: true, // Let vertical scrolling work normally
      selectedAttraction: 0.015,
      friction: 0.25
    });

    // Add prev/next classes on slide change
    flickityInstance.on('select', function () {
      flickityInstance.cells.forEach(cell => {
        cell.element.classList.remove('is-prev', 'is-next');
      });

      // Only apply prev/next if there are more than 2 slides
      if (flickityInstance.cells.length > 2) {
        let prevIndex = flickityInstance.selectedIndex - 1;
        let nextIndex = flickityInstance.selectedIndex + 1;

        // Wrap around logic
        if (flickityInstance.options.wrapAround) {
          if (prevIndex < 0) prevIndex = flickityInstance.cells.length - 1;
          if (nextIndex >= flickityInstance.cells.length) nextIndex = 0;
        }

        if (flickityInstance.cells[prevIndex]) {
          flickityInstance.cells[prevIndex].element.classList.add('is-prev');
        }

        if (flickityInstance.cells[nextIndex]) {
          flickityInstance.cells[nextIndex].element.classList.add('is-next');
        }
      }
    });

    // Initial trigger to set prev/next on load
    flickityInstance.on('ready', function () {
      flickityInstance.select(flickityInstance.selectedIndex);
    });

    // Initial trigger after initialization
    setTimeout(() => flickityInstance.select(flickityInstance.selectedIndex), 300);
  }

  function setupPreparationSliders() {
    const sections = document.querySelectorAll('.preparation-suggestion-section');

    sections.forEach(section => {
      initPreparationsSlider(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupPreparationSliders();

    // Debounced resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setupPreparationSliders, 300);
    });

    // Shopify Section Events
    const events = [
      'shopify:section:load',
      'shopify:section:select',
      'shopify:section:deselect',
      'shopify:block:select',
      'shopify:block:deselect',
      'shopify:section:reorder',
      'shopify:theme-settings:updated'
    ];

    events.forEach(eventName => {
      document.addEventListener(eventName, function (event) {
        const sectionId = event.detail?.sectionId;
        const section = document.querySelector(`.preparation-suggestion-section[data-section-id="${sectionId}"]`);
        if (section) {
          setTimeout(() => initPreparationsSlider(section), 300);
        }
      });
    });
  });
})();
